var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeTrial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_314_649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6667 8.33337V45C46.6667 45.9206 45.9205 46.6667 45 46.6667H8.33334C8.33334 48.5076 9.82573 50 11.6667 50H45C47.7615 50 50 47.7615 50 45V11.6667C50 9.82577 48.5076 8.33337 46.6667 8.33337Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3333 38.3333V5C43.3333 2.23854 41.0948 0 38.3333 0H5C2.23854 0 0 2.23854 0 5V38.3333C0 41.0948 2.23854 43.3333 5 43.3333H38.3333C41.0948 43.3333 43.3333 41.0948 43.3333 38.3333ZM30.4931 20.4736C30.4899 20.4769 30.4866 20.4801 30.4833 20.4833L23.3333 27.65L16.1833 20.5C15.5332 19.8538 14.4834 19.8538 13.8333 20.5L3.33333 30.9833V5C3.33333 4.07948 4.07948 3.33333 5 3.33333H38.3333C39.2539 3.33333 40 4.07948 40 5V27.65L32.85 20.5C32.2065 19.8419 31.1513 19.8301 30.4931 20.4736Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 8.33337C20.5719 8.33337 18.3333 10.5719 18.3333 13.3334C18.3333 16.0948 20.5719 18.3334 23.3333 18.3334C26.0948 18.3334 28.3333 16.0948 28.3333 13.3334C28.3333 10.5719 26.0948 8.33337 23.3333 8.33337ZM23.3333 15C22.4128 15 21.6667 14.2539 21.6667 13.3334C21.6667 12.4129 22.4128 11.6667 23.3333 11.6667C24.2539 11.6667 25 12.4129 25 13.3334C25 14.2539 24.2539 15 23.3333 15Z",
    fill: "#262626"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_314_649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeTrial);
export default __webpack_public_path__ + "static/media/free-trial.b51886843af6dedc2de05300e3bb124f.svg";
export { ForwardRef as ReactComponent };